import { useParams } from "react-router-dom";

import { Breadcrumbs } from "ui/breadcrumbs";

import { useCurrentClient } from "hooks/api/use-clients";

import { getClientPaths } from "utilities/app-routes";

const ThemePageHeader = () => {
  const currentClient = useCurrentClient();
  const { clientId } = useParams<{ clientId: string }>();

  const { clientCampaignsPath } = getClientPaths({ clientId });

  return (
    <div className="flex items-center">
      <Breadcrumbs
        breadcrumbs={[
          { label: currentClient?.name, href: clientCampaignsPath },
          { label: "Theme", active: true },
        ]}
      />
    </div>
  );
};

export default ThemePageHeader;
